import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonosSection() {
  const bonos = [{
    id: '01',
    emoji: '🚀',
    title: 'Kit Express del Primer Año',
    desc: 'Entrá al primer año de vida de tu hijo con todo claro, todo armado y sin improvisar. Protocolo del recién nacido semana a semana, checklist de los 10 hitos esenciales, guía de observación del desarrollo en 6 dimensiones, tarjetas de alto contraste listas para imprimir y guía de primeras palabras con script para estimular el lenguaje desde el día 1.',
    value: '$8.000'
  }, {
    id: '02',
    emoji: '💬',
    title: 'Banco de Respuestas para Pediatra, Maestra y Familia',
    desc: 'Las palabras exactas para cada momento de duda. 50+ scripts listos: cómo hablar con el pediatra sobre hitos, cómo explicarle a la abuela por qué no le dás pantallas, qué decirle a la maestra cuando algo no cierra, cómo manejar comentarios de comparación y cómo pedir derivación a un especialista sin miedo.',
    value: '$9.000'
  }, {
    id: '03',
    emoji: '✅',
    title: 'Checklists de Estimulación de Bolsillo',
    desc: 'El recordatorio exacto que necesitás para estimular mejor sin desgaste mental. 25 checklists por etapa: mañana con bebé, juego activo, salida al parque, baño estimulante, lectura compartida, tiempo de pantalla consciente y rutina de dormir. Formato bolsillo + 10 tarjetas imprimibles para el refrigerador.',
    value: '$7.000'
  }, {
    id: '04',
    emoji: '📊',
    title: 'Mapa de Intereses y Motivadores por Edad',
    desc: 'Descubrí más rápido qué realmente mueve a tu hijo en cada etapa. Los 5 tipos de juego por edad, tabla de intereses evolutivos, guía de elección de juguetes sin gastar de más, los 8 errores más comunes al estimular y protocolo para días difíciles cuando nada funciona.',
    value: '$8.000'
  }];
  return <section className="py-20 bg-black text-white relative overflow-hidden" data-id="element-20">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-sky-500/20 rounded-full blur-3xl" data-id="element-21"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl" data-id="element-22"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-400/20 text-amber-400 mb-6" data-id="element-25">
            <Gift className="w-8 h-8" data-id="element-26" />
          </div>
          <h2 className="md:text-4xl font-extrabold mb-4 text-[24px]" data-id="element-27">
            🎁 4 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-amber-400 font-bold" data-id="element-28">SIEMPRE INCLUIDOS</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-29">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-sky-950/80 border border-sky-900 rounded-2xl p-6 flex flex-col h-full relative overflow-hidden group hover:border-sky-600/60 transition-colors" data-id="element-30">
              <div className="absolute top-0 right-0 bg-sky-900 text-sky-300 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-31">
                Bono {bono.id}
              </div>

              <div className="flex items-start gap-4 mb-4 mt-2" data-id="element-32">
                <div className="text-4xl" data-id="element-33">{bono.emoji}</div>
                <div data-id="element-34">
                  <h3 className="text-xl font-bold text-white leading-tight mb-2" data-id="element-35">
                    {bono.title}
                  </h3>
                  <p className="text-sky-200/80 text-sm leading-relaxed" data-id="element-36">
                    {bono.desc}
                  </p>
                </div>
              </div>

              <div className="mt-auto pt-4 border-t border-sky-900 flex items-center justify-between" data-id="element-37">
                <span className="text-sky-500 line-through text-sm" data-id="element-38">
                  Valor {bono.value}
                </span>
                <span className="text-amber-400 font-black tracking-wide" data-id="element-39">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-40">
          <div className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-8 py-4" data-id="element-41">
            <p className="text-lg" data-id="element-42">
              Valor total bonos{' '}
              <span className="line-through opacity-50" data-id="element-43">$32.000</span>{' '}
              <span className="text-amber-400 font-bold mx-2" data-id="element-44">→</span>{' '}
              <span className="font-black text-xl" data-id="element-45">GRATIS con tu Megapack</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}